import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.242 6.003h12m-12 6.003h12m-12 6h12M4.116 7.506v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.576a1.125 1.125 0 1 1 1.591 1.591l-1.829 1.83h2.159M2.99 15.755h1.125a1.125 1.125 0 1 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 1 1 0 2.25H2.99"
    }, null, -1)
  ])))
}
export default { render: render }